import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { faEllipsisH, faTrashAlt, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { formatItemDate } from "../../helpers/";
import AddActivity from "../AddActivity";
import DeleteActivity from "../DeleteActivity";
import { useSelector } from "react-redux";

const ItemStyle = styled.div`
  .white {
    background: #fff;
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;

    a {
      color: #aaaaaa;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .card {
    .top {
      display: flex;
      justify-content: space-between;
      color: #aaaaaa;

      span {
        font-size: 13px;
        margin-left: 5px;
      }
    }

    .title {
      margin: 15px 0;
	  color: #5f5f5f;
	  min-height:48px;
    }
    .initials {
      position: relative;
    }
    .initial {
      background: #e5f3fe;
      width: 60px;
      height: 60px;
      margin: auto;
      line-height: 60px;
      border-radius: 50%;
      color: #0184fe;
      display: inline-block;
    }
    .initial-main {
      border: solid 1px #fff;
      background: #e5f3fe;
      width: 60px;
      height: 60px;
      line-height: 60px;
      border-radius: 50%;
      color: #0184fe;
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
    .status {
		width: 20px;
		height: 20px;
		border-radius: 20px;
		margin:auto;
	}
	.scheduled{
		width: 100%;
    	height: 20px;import { formatItemDate } from "../../helpers/";
    	border-radius: 20px;
    	margin: auto;
    	border: solid 1px #707070;
    	font-size: 13px;
    	color: #707070;
	}
	.top-left{
		float:left;
		width:60%;
	}
	.top-right{
		float:right;
		width:40%;
		text-align:right;
		a{
			padding-left:8px;
		}
	}
  }
`;

const getUsers = users => {
	if (!users || users.length === 0) return "";

	return users.length === 3 ? (
		<div className="initials">
			<div className="initial-main">
				{users[0].name.charAt(0)}
				{users[0].surname.charAt(0)}
			</div>
			<div className="initial">
				{users[1].name.charAt(0)}
				{users[1].surname.charAt(0)}
			</div>
			<div className="initial">
				{users[2].name.charAt(0)}
				{users[2].surname.charAt(0)}
			</div>
		</div>
	) : users.length === 2 ? (
		<div className="initials">
			<div className="initial">
				{users[0].name.charAt(0)}
				{users[0].surname.charAt(0)}
			</div>
			<div className="initial">
				{users[1].name.charAt(0)}
				{users[1].surname.charAt(0)}
			</div>
		</div>
	) : (
				<div className="initial">
					{users[0].name.charAt(0)}
					{users[0].surname.charAt(0)}
				</div>
			);
};

function Item(props) {
	const dependencies = useSelector(state => state.dependencies);
	const [show, setShow] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	const currentUser = useSelector(state => state.currentUser);

	const handleClose = () => setShow(false);
	const handleDelete = () => setShowDelete(false);

	const handleShow = function (event) {
		event.preventDefault();
		setShow(true);
	};

	const handleDeleteShow = function (event) {
		event.preventDefault();
		setShowDelete(true);
	};

	const deleteItem = function (event) {
		event.preventDefault();
		setShowDelete(true);
	};

	const getCurrentStatus = item => {

		let date = new Date();

		if (item.status === "completed") {
			return "completed";
		}

		if (item.status === "hold") {
			return "hold";
		}

		if (new Date(item.start) > date) {
			return "scheduled";
		}

		if (date > new Date(item.finish)) {
			return "delayed";
		}
		let warning = false;
		dependencies.map((dept, index) => {
			if (dept.children.findIndex(x => x == item.key) !== -1) {

				if (dept.status == 'hold' || (dept.status == 'scheduled' && new Date() > new Date(dept.finish))) {

					warning = true;

				}
			}
		});
		if (warning) {
			return 'warning';
		} else {
			return "progress";
		}
	};

	return (
		<ItemStyle>
			<div className="white card">
				<div className="top">
					<div className="top-left">
						<p>
							<FontAwesomeIcon icon={faCalendar} />
							<span>{formatItemDate(props.item.finish)}</span>
						</p>
					</div>
					<div className="top-right">
						{currentUser.role && currentUser.role === 'admin' ?
							<a onClick={handleDeleteShow} href="#">
								<FontAwesomeIcon icon={faTrashAlt} />
							</a>
							: ''}
						<a onClick={handleShow} href="#">
							<FontAwesomeIcon icon={faInfoCircle} />
						</a>

					</div>
				</div>
				<div className="d-flex flex-column text-center">
					{getUsers(props.item.users)}
					<p className="title">{props.item.name}</p>
					{getCurrentStatus(props.item) !== 'scheduled' ?
						<div className={`status ${getCurrentStatus(props.item)}`}></div>
						: <div className="scheduled">Scheduled</div>}

				</div>
			</div>
			<AddActivity show={show} onHide={handleClose} item={props.item} deliverable={props.deliverable ? props.deliverable : false} />
			<DeleteActivity show={showDelete} onHide={handleDelete} item={props.item} deleteItem={deleteItem} deliverable={props.deliverable ? props.deliverable : false} />
		</ItemStyle>
	);
}

export default Item;
